var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_704_2059",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_704_2059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_2",
    d: "M10 10.9408L5.83492 15.1058C5.70565 15.2351 5.55368 15.2976 5.379 15.2933C5.20433 15.2891 5.04969 15.2196 4.91508 15.085C4.78046 14.9504 4.71314 14.7936 4.71314 14.6147C4.71314 14.4357 4.78046 14.2789 4.91508 14.1443L9.05931 10.0001L4.89425 5.83499C4.76497 5.70572 4.70247 5.55028 4.70675 5.36865C4.71101 5.18704 4.78046 5.02893 4.91508 4.89432C5.04969 4.7597 5.20647 4.69238 5.38542 4.69238C5.56436 4.69238 5.72114 4.7597 5.85575 4.89432L10 9.05938L14.1651 4.89432C14.2943 4.76504 14.4498 4.69907 14.6314 4.6964C14.813 4.69372 14.9711 4.7597 15.1057 4.89432C15.2404 5.02893 15.3077 5.18571 15.3077 5.36465C15.3077 5.5436 15.2404 5.70038 15.1057 5.83499L10.9407 10.0001L15.1057 14.1652C15.235 14.2944 15.301 14.4464 15.3037 14.6211C15.3063 14.7957 15.2404 14.9504 15.1057 15.085C14.9711 15.2196 14.8144 15.2869 14.6354 15.2869C14.4565 15.2869 14.2997 15.2196 14.1651 15.085L10 10.9408Z",
    fill: "#9CA3AF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.502b821953d55d04a500eb610fc580c3.svg";
export { ForwardRef as ReactComponent };